import React,{useState} from 'react'
import {ROOM_OPTIONS,COUNT_OPTIONS} from '../constant'
import Button from '../components/Button'
import Content from '../components/Content'
import SelectField from '../components/SelectField';
import bg from "../images/IMG_0095.jpg"
import Footer from '../components/Footer'
import quote from "../images/svg/blackquote.svg"
import Nav from '../components/Nav'
import Testimonials from "../components/carousels/Testimonials"
import birthday from "../images/birthday2.JPG"
import reception from "../images/reception.JPG"
import gal2 from "../images/gal2.JPG"
import room1 from "../images/dulex.JPG"
import gal3 from "../images/gal3.JPG"
import sarvoday from "../images/sarvoday.mp4"
const Restaraunt = () => {
     const [room,setRoom]=useState()
    const [children,setChildren]=useState()
    const [adult,setAdult]=useState()
    
  return (
    <div>
       
        <div className="h-3/4 bg bg-center bg-cover">
        <div className="h-full z-10 overlay">
          <Nav color={true}/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">RESTAURANT</p>
          </div>
          </div>
          </div>
          <div className="bg-black w-full">
           <div className="w-2/3 bg-black mx-auto text-white text-center p-5 md:text-2xl sm:text-xl font-semibold">BOOK YOUR TABLE</div>

        <div className=" bg-black container w-2/3 mx-auto content-evenly grid md:grid-rows-2 md:grid-cols-4 md:grid-flow-col gap-4 text-xl sm:grid-rows-8 sm:grid-cols-1 sm:grid-flow-row text-white">
       <span>Room</span>
         <span><SelectField 
          options={ROOM_OPTIONS}
          changeHandler={setRoom}
          selectedValue={room}/></span>
         <span>Adults</span>
         <span><SelectField 
          options={COUNT_OPTIONS} changeHandler={setAdult}
          selectedValue={adult}/></span>
          <span>Children</span>

          <span><SelectField 
         options={COUNT_OPTIONS} changeHandler={setChildren}
          selectedValue={children}/></span>
           <span></span>
          <span>
            <button className="w-full text-center font-semibold border-2 border-[#d2a960] text-white px-4 py-2">BOOK NOW</button>
  </span>
    </div>       <div className="restaraunt bg-cover bg-center">
               <div className=" overlay z-10 h-screen w-full p-3 py-6">
     <div className="p-10 text-center"><Content isColor={true} title="HOTEL SARVODAY"/>
     <p className="text-4xl text-center text-white font-semibold">Restaraunt Menu</p></div>
     <div className="container mx-auto w-full m-10 p-5 grid md:grid-cols-2 gap-5 grid-cols-1 text-white">
          <div className="mx-auto grid grid-cols-3">
            <div className="text-2xl text-[rgb(210,169,96)]">Lorem ipsum dolor sit amet</div>
            <div className="place-self-center w-full p-5"><div className="align-middle p-1 border-y-2 border-[#d2a960]"></div>
           </div> <div className=" text-3xl text-[#d2a960]">$12</div>
            
            <div className="col-span-2">English muffin, beef, hollandaise sauce, poached egg.</div>
            </div>
              <div className="grid grid-cols-3 ">
            <div className="text-2xl text-[rgb(210,169,96)]">Lorem ipsum dolor sit amet</div>
            <div className="place-self-center w-full p-5"><div className="align-middle p-1 border-y-2 border-[#d2a960]"></div>
           </div> <div className=" text-3xl text-[#d2a960]">$12</div>
            
            <div className="col-span-2">English muffin, beef, hollandaise sauce, poached egg.</div>
            </div>
               <div className="grid grid-cols-3">
            <div className="text-2xl text-[rgb(210,169,96)]">Lorem ipsum dolor sit amet</div>
            <div className="place-self-center w-full p-5"><div className="align-middle p-1 border-y-2 border-[#d2a960]"></div>
           </div> <div className=" text-3xl text-[#d2a960]">$12</div>
            
            <div className="col-span-2">English muffin, beef, hollandaise sauce, poached egg.</div>
            </div>
        <div className="grid grid-cols-3">
            <div className="text-2xl text-[rgb(210,169,96)]">Lorem ipsum dolor sit amet</div>
            <div className="place-self-center w-full p-5"><div className="align-middle p-1 border-y-2 border-[#d2a960]"></div>
           </div> <div className=" text-3xl text-[#d2a960]">$12</div>
            
            <div className="col-span-2">English muffin, beef, hollandaise sauce, poached egg.</div>
            </div>
            </div>
            <div className="text-center mx-auto w-full"><Button isColour={true} href="/menu" label='VIEW ALL'/>
    </div>
    <div className="w-4/5 m-10 p-10 mx-auto bg-[#d2a960] grid md:grid-cols-3 grid-cols-1">
      <div className="text-center text-white text-4xl text-bold col-span-2">We are always here to help you.
you don't hesitate to contact with us</div>

<div className="place-self-center align-middle"><Button href="/contact" label="CONTACT NOW"/></div>
      </div>
      </div></div>
      </div>
      <div className="bg-black w-full py-10">
      <div className="bg-black w-4/5 gap-5 mx-auto grid md:grid-cols-3 grid-cols-1 grid-flow-row">
        <div><Content isColor="chrome" title="ABOUT US"
        subtitle="lorem ipsum lorem"
        content="Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod neque minus, ducimus dolore veniam aspernatur optio quibusdam itaque, placeat, aliquam sit hic! Nam nihil fugiat aut totam, sequi unde nostrum."/></div>
       
        <div><img className="bg-cover" src={reception} alt="bg"/></div>
        <div><img  className="bg-cover" src={bg} alt="bg"/></div></div>
          
        </div>
<video className="w-screen" src={sarvoday}  controls="controls" autoplay="true" />
<div className="bg-black">
  <div className="w-3/4 mx-auto pt-20">
    <img className="bg-center m-auto place-self-center" src={quote} width="50px" height="50px" alt="icon"/>
  <Testimonials/></div>
</div>
<div className="w-full grid md:grid-cols-5 grid-cols-1">
  <img className="bg-cover" src={gal2} alt="img"/>
  <img className="bg-cover" src={gal3} alt="img"/>
  <img className="bg-cover" src={room1} alt="img"/>
  <img className="bg-cover" src={reception} alt="img"/>
  <img className="bg-cover" src={birthday} alt="img"/>
</div>
<Footer isColour={true}/>
     </div>
     
   
        
    
  )
}

export default Restaraunt